// Traditional Chinese (Taiwan register) — default locale.
export default {
  translation: {
    appName: 'PetPro 線上預約',
    loading: '載入中…',
    back: '上一步',
    next: '下一步',
    confirm: '確認預約',
    retry: '重試',

    notFound: {
      title: '找不到預約頁面',
      body: '這個預約連結可能已停用或不存在。',
    },

    liff: {
      connecting: '正在連接 LINE…',
      error: '無法連接 LINE，請從 LINE 重新開啟，或改用手機號碼預約。',
    },

    steps: {
      service: '服務',
      dates: '日期與房型',
      details: '寵物資料',
      verify: '手機驗證',
      done: '完成',
    },

    service: {
      title: '選擇服務',
      boarding: '寵物住宿',
      daycare: '日間托育',
      grooming: '美容',
      boardingDesc: '過夜住宿照護',
      daycareDesc: '白天托育，當日接回',
      groomingDesc: '洗澡、美容、修剪',
    },

    grooming: {
      title: '選擇服務與時段',
      chooseService: '選擇服務項目',
      duration: '{{count}} 分鐘',
      chooseGroomer: '選擇美容師',
      anyGroomer: '不指定',
      anyGroomerHint: '安排最快有空的美容師',
      date: '日期',
      findTimes: '查詢可預約時段',
      noSlots: '這天沒有可預約時段，請改選其他日期。',
      pickTime: '選擇時段',
      time: '時段',
      from: '起',
    },

    addon: {
      title: '要加購美容嗎？',
      subtitle: '可在這次預約中一併加購一次美容服務。',
      add: '加購美容',
      skip: '不用了',
      tag: '加購美容',
      total: '加購小計',
    },

    dates: {
      title: '選擇日期',
      checkIn: '入住日期',
      checkOut: '退房日期',
      search: '查詢空房',
      noRooms: '所選日期沒有可預約的房型，請改選其他日期。',
      perNight: '／晚',
      room: '房型',
      capacity: '可容納 {{count}} 隻',
      selectRoom: '選擇房型',
    },

    details: {
      title: '寵物與聯絡資料',
      petName: '寵物名字',
      species: '物種',
      breed: '品種（選填）',
      notes: '備註（選填）',
      ownerName: '您的姓名',
      phone: '手機號碼',
      phoneHint: '我們會傳送驗證碼到這支號碼',
      specialInstructions: '特殊照護需求（選填）',
      dog: '狗',
      cat: '貓',
      other: '其他',
    },

    verify: {
      title: '手機驗證',
      sent: '驗證碼已發送至 {{phone}}',
      codeLabel: '請輸入 6 位數驗證碼',
      sendCode: '發送驗證碼',
      resend: '重新發送',
      verifying: '驗證中…',
      devCode: '開發模式驗證碼：{{code}}',
    },

    review: {
      title: '確認預約內容',
      service: '服務',
      dates: '日期',
      pet: '寵物',
      contact: '聯絡人',
      submitting: '送出中…',
    },

    done: {
      requestedTitle: '已收到您的預約申請',
      requestedBody: '商家確認後會通知您。預約狀態：等待確認。',
      confirmedTitle: '預約成功！',
      confirmedBody: '期待為您的毛孩服務。',
      reference: '預約編號',
      bookAnother: '再預約一筆',
    },

    errors: {
      generic: '發生錯誤，請稍後再試。',
      rateLimited: '嘗試次數過多，請稍後再試。',
      clinicFull: '此店家目前預約額滿，暫時無法接受新客戶線上預約，請直接與店家聯繫。',
      badCode: '驗證碼錯誤或已過期。',
      tokenExpired: '驗證已逾時，請重新驗證手機。',
      tokenExpiredLiff: '連線階段已逾時，請再次送出。',
      required: '此欄位為必填。',
    },

    packages: {
      // Catalog card
      buy: '購買',
      sessions: '{{n}} 次',
      bonusSuffix: ' (含 {{n}} 次贈)',
      validity: '有效期 {{n}} 天',
      transferHousehold: '家庭套票 — 同戶寵物皆可用',
      transferOwnerOnly: '單寵物使用',

      // Checkout sheet
      sheetTitle: '購買 {{name}}',
      sheetSummary: '{{n}} 次 · {{price}}',
      refundNone: '⚠️ 不可退款 — 售出後恕無法退費',
      refundProrated: '退款政策：按已使用次數比例退款 (扣除手續費)',
      refundProratedWithFee: '退款政策：比例退款 — 另收提早終止費用',
      refundFullWithinWindow: '退款政策：購買後一段期間內可全額退款 (尚未使用)',
      einvoiceNotice: '發票由 Camus 平台統一開立，請勿要求商家另行開立。',
      petLabel: '適用寵物 *',
      petHint: '此套票限單一寵物使用，購買後不可更換。',
      petNeedVerify: '請先完成手機驗證，才能選擇適用寵物。',
      petAddMore: '新增寵物',
      petAddFirst: '新增我的寵物',
      petNamePlaceholder: '寵物名字',
      einvoiceCarrierLabel: '載具條碼 (例：/AB12345)',
      einvoiceTaxIdLabel: '或統一編號 (8 位)',
      consent: '我已閱讀並同意退款條款與本套票之相關規定。',
      cancel: '取消',
      paying: '結帳中…',
      pay: '付款 {{price}}',
      errNeedVerify: '請先驗證手機號碼才能購買套票',
      errNeedConsent: '請勾選同意條款',
      errNeedEinvoice: '請提供載具條碼或統一編號',
      errNeedPet: '此套票限單一寵物使用，請選擇適用寵物',
      errNeedPetName: '請輸入寵物名字',
      errCheckoutFailed: '結帳失敗，請稍後再試',

      // Post-payment return
      returnConfirmingTitle: '確認付款中…',
      returnConfirmingBody: '正在向金流確認您的套票，請稍候。',
      returnSuccessTitle: '✅ 購買成功',
      returnSuccessBody: '已為您加值「{{name}}」，共 {{n}} 次。',
      returnSuccessBodyExpiry: '已為您加值「{{name}}」，共 {{n}} 次，效期至 {{date}}。',
      returnSuccessGeneric: '付款完成，您的套票已開通。可於預約時選用。',
      returnPendingTitle: '付款處理中',
      returnPendingBody:
        '我們已收到您的付款，套票開通可能需要幾秒鐘。稍後可於「我的套票」查看。',
      returnCancelTitle: '已取消結帳',
      returnCancelBody: '您尚未完成付款，套票未購買。',
      close: '關閉',

      // Header CTA + catalog
      headerCta: '🎁 套票方案 ({{n}})',
      catalogTitle: '預付套票方案',

      // Redeem picker
      redeemTitle: '使用預付套票？',
      redeemSubtitle: '此次預約將扣抵 {{n}} 次',
      redeemNone: '不使用套票（之後付款）',
      redeemOption: '{{name}} · 剩餘 {{remaining}}/{{total}} 次',
      redeemInsufficientTag: ' (次數不足)',
      redeemInsufficientHint: '您的套票剩餘次數不足以涵蓋此次預約',

      // Add-on picker
      addonTitle: '加購服務（選填）',
      decrease: '減少',
      increase: '增加',
    },
  },
}
